import Constants from 'Constants'
import Common from '@/assets/js/common.js'

let _privacyPolicyCache = null

let ContractMixin = {
	methods: {
		getContractByTiers: async function() {
            const url = this.constructRoute(Constants.CONTRACT_TIERS_URL, {contract_id: ''}) + "?licence_key=" + Constants.USER_LICENCE_KEY
            const result = await this.$request.request_get_api("ContractMixin::getContractByTiers", url)
            .catch(error => {
                console.error("ContractMixin::getContractByTiers => ERROR", error)
                return null
            })
            if(result && result.retour) return result.retour
            return null
		},

        getContractByTiersAndHorse: async function(horse_id) {
            const url = this.constructRoute(Constants.CONTRACT_TIERS_HORSE_URL, {horse_id}) +'?licence_key='+Constants.USER_LICENCE_KEY
            const result = await this.$request.request_get_api("ContractMixin::getContractByTiersAndHorse", url)
            .catch(error => {
                console.error("ContractMixin::getContractByTiersAndHorse => ERROR", error)
                return null
            })
            if(result && result.retour) return result.retour
            return null
        },

        /**
         * Crée un nouveau contrat pour le tiers spécifié.
         * @param {number|null} tiers_id - Identifiant du tiers à associer au contrat.
         * @returns {Object|null} Le contrat créé, ou null en cas d'erreur.
         */
        addContract: async function(tiers_id = null) {
            const url = this.constructRoute(Constants.CONTRACT_TIERS_URL, {contract_id: ''}) + "?licence_key=" + Constants.USER_LICENCE_KEY
            const result = await this.$request.request_post_api("ContractMixin::addContract", url, tiers_id ? { tiers_id } : undefined, false)
            .catch(error => {
                console.error("ContractMixin::addContract => ERROR", error)
                return null
            })
            if(result && result.retour) return result.retour
            return null
        },

        getContract: async function(contract_id) {
            const url = this.constructRoute(Constants.CONTRACT_TIERS_URL, {contract_id}) + "?licence_key=" + Constants.USER_LICENCE_KEY
            const result = await this.$request.request_get_api("ContractMixin::getContract", url)
            .catch(error => {
                console.error("ContractMixin::getContract => ERROR", error)
                return null
            })
            if(result && result.retour) return result.retour[0]
            return null
        },

        loadSeasons: async function() {
            const url = Constants.SEASON_LIST_URL + "?licence_key=" + Constants.USER_LICENCE_KEY
            const result = await this.$request.request_get_api("ContractMixin::loadSeasons", url)
            .catch(error => {
                console.error("ContractMixin::loadSeasons => ERROR", error)
                return null
            })
            if(result && result.retour) return result.retour
            return null
        },

        getSeasonStallions: async function(season_id) {
            const url = this.constructRoute(Constants.STALLION_SEASON_URL, {season_id}) + "?licence_key=" + Constants.USER_LICENCE_KEY
            const result = await this.$request.request_get_api("ContractMixin::addContract", url)
            .catch(error => {
                console.error("ContractMixin::getSeasonStallions => ERROR", error)
                return null
            })
            if(result && result.retour) return result.retour
            return null
        },

        loadAllModel: async function(modelable_id) {
            const url = this.constructRoute(Constants.MODEL_URL, {modelable_id: modelable_id, modelable_type: 'contract_config'}) + "?licence_key="+Constants.USER_LICENCE_KEY
            const result = await this.$request.request_get_api("ModelMixin::loadAllModel", url)
            .catch(error => {
                console.error("ModelMixin::loadAllModel => ERROR", error)
                return null
            })
            if(result && result.retour) return result.retour
            return null
        },

        getContractsConfigByStallionAndSeason: async function(horse_id, season_id) {
            const url = this.constructRoute(Constants.HORSE_CONTRACT_CONFIG_URL, {horse_id: horse_id, season_id: season_id}) + "?licence_key="+Constants.USER_LICENCE_KEY
            const result = await this.$request.request_get_api("ContractMixin::getContractsConfigByStallionAndSeason", url)
            .catch(error => {
                console.error("ContractMixin::getContractsConfigByStallionAndSeason => ERROR", error)
                return null
            })
            if(result && result.retour) return result.retour
            return null
        },

        /**
         * Récupère les types de monte disponibles pour une configuration de contrat.
         * Filtre les conditions selon les tarifs du tiers si tiers_id est fourni.
         * @param {number} contractconfig_id - Identifiant de la configuration de contrat.
         * @param {number|null} tiers_id - Identifiant du tiers (optionnel, pour filtrage tarifaire).
         * @returns {Array} Liste des types de monte disponibles.
         */
        getContractConfigTypeMonte: async function(contractconfig_id, tiers_id = null) {
            let url = this.constructRoute(Constants.CONTRACT_CONFIG_TYPE_MONTE_URL, {contractconfig_id: contractconfig_id}) + "?licence_key="+Constants.USER_LICENCE_KEY
            if (tiers_id) url += `&tiers_id=${tiers_id}`
            const result = await this.$request.request_get_api("ContractMixin::getContractsConfigByStallionAndSeason", url)
            .catch(error => {
                console.error("ContractMixin::getContractsConfigByStallionAndSeason => ERROR", error)
                return null
            })
            if(result && result.retour) return result.retour
            return null
        },

        saveContract: async function(contract_id, form) {
            const url = this.constructRoute(Constants.CONTRACT_TIERS_URL, { contract_id }) + "?licence_key="+Constants.USER_LICENCE_KEY
            const result = await this.$request.request_post_api("ContractMixin::saveContract", url, { form })
            .catch(error => {
                console.error("ContractMixin::saveContract => ERROR", error)
                return null
            })
            if(result && result.retour) return result.retour
            return null
        },

        getContractConfigTypeMonteFromId: async function(typemonte_id) { 
            const url = this.constructRoute(Constants.CONTRACT_TYPE_MONTE_URL, {typemonte_id: typemonte_id}) + "?licence_key="+Constants.USER_LICENCE_KEY
            const result = await this.$request.request_get_api("ContractMixin::getContractConfigTypeMonteFromId", url)
            .catch(error => {
                console.error("ContractMixin::getContractConfigTypeMonteFromId => ERROR", error)
                return null
            })
            if(result && result.retour) return result.retour
            return null
        },

        printContract: async function(contract_id, return_stream = false) {           
            const url = this.constructRoute(Constants.CONTRACT_PRINT_URL, { contract_id }) + "?licence_key="+Constants.USER_LICENCE_KEY
			const result = await this.$request.request_get_api("ContractMixin::printContract", url)
			.catch(error => {
				console.error("ContractMixin::printContract => ERROR", error)
				return null
			})
            if(return_stream){
                return result
            }
            Common.base64ToPdf(result, "contract_" + contract_id + ".pdf")
            return true
		},

        contractAutoInvoice: async function(contract_id, contract_invoice_mode) {
            const url = this.constructRoute(Constants.CONTRACT_AUTO_INVOICE_URL, { contract_id}) + "?licence_key="+Constants.USER_LICENCE_KEY
            return this.$request.request_post_api("ContractMixin::saveContract", url, {mode: contract_invoice_mode }, false)
                .then(res => res.retour)
                .catch(e => {
                    console.error("ContractMixin::contractAutoInvoice => ERROR", e)
                    return null
                })
        },

        /**
         * Enregistre la signature d'un contrat à partir des données d'un canvas HTML.
         * @param {number} contract_id - Identifiant du contrat à signer.
         * @param {string} signature_data - Image base64 (data URL PNG) de la signature tracée.
         * @returns {Object|null} La réponse de l'API ou null.
         * @throws {Error} Propage l'erreur réseau pour traitement dans l'appelant.
         */
        signContractWithCanvas: async function(contract_id, signature_data) {
            const url = this.constructRoute(Constants.CONTRACT_SIGN_CANVAS_URL, { contract_id }) + '?licence_key=' + Constants.USER_LICENCE_KEY
            return this.$request.request_post_api('ContractMixin::signContractWithCanvas', url, { signature_data }, false)
                .then(res => (res && res.retour) ? res.retour : null)
                .catch(error => {
                    console.error('ContractMixin::signContractWithCanvas => ERROR', error)
                    throw error
                })
        },

        contractInvoiceMode: async function() {
            const url = Constants.CONTRACT_INVOICE_MODE_URL + "?licence_key="+Constants.USER_LICENCE_KEY

			return this.$request.request_get_api("ContractMixin::contractAutoInvoice", url)
                .then(res => res.retour)
                .catch(error => {
                    console.error("ContractMixin::contractAutoInvoice => ERROR", error)
                    return null
                })
        },

        contractPrivacyPolicy: async function() {
            if (_privacyPolicyCache) {
                return _privacyPolicyCache
            }
            const url = Constants.CONTRACT_PRIVACY_POLICY_URL + "?licence_key="+Constants.USER_LICENCE_KEY
            _privacyPolicyCache = this.$request.request_get_api("ContractMixin::printContract", url)
                .then(res => res.retour)
                .catch(error => {
                    console.error("ContractMixin::printContract => ERROR", error)
                    _privacyPolicyCache = null
                    return null
                })
            return _privacyPolicyCache
        },

        /**
         * Détermine si la période de création de contrats est actuellement fermée.
         * @param {Object|null} privacy - Réponse de contractPrivacyPolicy().
         * @returns {{ closed: boolean, message: string }}
         */
        isContractCreationClosed(privacy) {
            if (!privacy || !privacy.start_contract || !privacy.end_contract) {
                return { closed: false, message: '' }
            }
            const now = new Date()
            const open = now >= new Date(privacy.start_contract) && now <= new Date(privacy.end_contract)
            return { closed: !open, message: privacy.text_contract || '' }
        },

        /**
         * Récupère l'URL de contrat sur la boutique marketplace.
         * @param {number} contract_id - Identifiant du contrat.
         * @returns {Object|null} Données retour de l'API (url, etc.), ou null.
         */
        getBoutiqueContractUrl: async function(contract_id, signature_data) {
            const url = Constants.MARKETPLACE_GET_BOUTIQUE_CONTRACT_URL + "?licence_key=" + Constants.USER_LICENCE_KEY
            const payload = { contract_ids: [contract_id] }
            if (signature_data) payload.signature_data = signature_data
            const result = await this.$request.request_post_api("ContractMixin::getBoutiqueContractUrl", url, payload, false)
                .catch(error => {
                    console.error("ContractMixin::getBoutiqueContractUrl => ERROR", error)
                    return null
                })
            if (result && result.retour) return result.retour
            return null
        },

        /**
         * Vérifie le statut du paiement et finalise le contrat si succès.
         * @param {Array<number>} contract_ids - Identifiants des contrats.
         * @returns {Object|null} { status: 'success'|'pending'|'error', contracts: [...] }
         */
        checkPaymentResult: async function(contract_ids) {
            const url = Constants.CONTRACT_PAYMENT_RESULT_URL + "?licence_key=" + Constants.USER_LICENCE_KEY
            const result = await this.$request.request_post_api("ContractMixin::checkPaymentResult", url, { contract_ids }, false)
                .catch(error => {
                    console.error("ContractMixin::checkPaymentResult => ERROR", error)
                    return null
                })
            if (result && result.retour) return result.retour
            return null
        },

        /**
         * Signe le contrat sans paiement (payer plus tard par virement).
         * @param {Array<number>} contract_ids - Identifiants des contrats.
         * @returns {Object|null} { status: 'success', contracts: [...] }
         */
        signContractPayLater: async function(contract_ids) {
            const url = Constants.CONTRACT_SIGN_PAY_LATER_URL + "?licence_key=" + Constants.USER_LICENCE_KEY
            return this.$request.request_post_api("ContractMixin::signContractPayLater", url, { contract_ids }, false)
                .then(res => (res && res.retour) ? res.retour : null)
                .catch(error => {
                    console.error("ContractMixin::signContractPayLater => ERROR", error)
                    throw error
                })
        },

        getContractConfigDefaultCmep: async function(contractconfig_id) {
            const url = this.constructRoute(Constants.CONTRACT_CONFIG_DEFAULT_CMEP, {contractconfig_id: contractconfig_id}) + "?licence_key="+Constants.USER_LICENCE_KEY
            const result = await this.$request.request_get_api("ContractMixin::getContractConfigDefaultCmep", url)
            .catch(error => {
                console.error("ContractMixin::getContractConfigDefaultCmep => ERROR", error)
                return null
            })
            if(result && result.retour) return result.retour
            return null
        },

        /**
         * Récupère l'identifiant du CMEP le plus fréquemment utilisé.
         * @param {number|null} tiers_id - Identifiant du tiers (optionnel, pour contextualiser le CMEP par défaut).
         * @returns {number|null} L'identifiant du CMEP ou null.
         */
        getMostUsedCmep: async function(tiers_id = null) {
            let url = Constants.CONTRACT_MOST_USED_CMEP + "?licence_key="+Constants.USER_LICENCE_KEY
            if(tiers_id) url += "&tiers_id=" + tiers_id
            const result = await this.$request.request_get_api("ContractMixin::getContractConfigDefaultCmep", url)
            .catch(error => {
                console.error("ContractMixin::getContractConfigDefaultCmep => ERROR", error)
                return null
            })
            if(result && result.retour) return result.retour
            return null
        },

        /** Retourne la liste des types d'acte de saillie disponibles pour la licence. */
        getActeTypesSaillie: async function() {
            const url = Constants.ACTE_TYPE_SAILLIE_URL + "?licence_key=" + Constants.USER_LICENCE_KEY
            const result = await this.$request.request_get_api("ContractMixin::getActeTypesSaillie", url)
            .catch(error => {
                console.error("ContractMixin::getActeTypesSaillie => ERROR", error)
                return null
            })
            if(result && result.retour) return result.retour
            return []
        },

        /**
         * Retourne les options de résultat pour le formulaire DG.
         * Cherche la question de type SEL dont le libellé est 'Résultat'
         * dans l'acte type REPRO_DIAGNOSTIC_DE_GESTATION et retourne son tableau data.
         */
        getDGResultOptions: async function() {
            const questions = await this.getActeTypeQuestionsByCode('REPRO_DIAGNOSTIC_DE_GESTATION')
            const resultatQ = questions.find(q => q.question_libelle === 'Résultat' || q.question_code === 'Résultat')
            return (resultatQ && resultatQ.question_questiondata && resultatQ.question_questiondata.data) ? resultatQ.question_questiondata.data : []
        },

        /**
         * Retourne les options de résultat pour le formulaire poulinage.
         * Cherche la première question SEL dans l'acte type REPRO_POULINAGE
         * (recherche plus souple que getDGResultOptions car le code question peut varier).
         */
        getPoulinageResultOptions: async function() {
            const questions = await this.getActeTypeQuestionsByCode('REPRO_POULINAGE')
            const resultatQ = questions.find(q =>
                q.question_libelle === 'Résultat' ||
                q.question_code === 'Résultat' ||
                (q.question_questiontype === 'SEL' && q.question_questiondata && q.question_questiondata.data && q.question_questiondata.data.length > 0)
            )
            return (resultatQ && resultatQ.question_questiondata && resultatQ.question_questiondata.data) ? resultatQ.question_questiondata.data : []
        },

        /** Retourne les questions d'un type d'acte à partir de son ID numérique. */
        getActeTypeQuestions: async function(actestype_id) {
            const url = this.constructRoute(Constants.ACTE_TYPE_QUESTIONS_URL, { actestype_id }) + '?licence_key=' + Constants.USER_LICENCE_KEY
            const result = await this.$request.request_get_api('ContractMixin::getActeTypeQuestions', url)
            .catch(error => {
                console.error('ContractMixin::getActeTypeQuestions => ERROR', error)
                return null
            })
            if (result && result.retour) return result.retour
            return []
        },

        /** Retourne les questions d'un type d'acte à partir de son code métier (ex. 'REPRO_POULINAGE'). */
        getActeTypeQuestionsByCode: async function(actestype_code) {
            const url = this.constructRoute(Constants.ACTE_TYPE_QUESTIONS_BY_CODE_URL, { actestype_code }) + '?licence_key=' + Constants.USER_LICENCE_KEY
            const result = await this.$request.request_get_api('ContractMixin::getActeTypeQuestionsByCode', url)
            .catch(error => {
                console.error('ContractMixin::getActeTypeQuestionsByCode => ERROR', error)
                return null
            })
            if (result && result.retour) return result.retour
            return []
        },

        /**
         * Endpoint unifié de déclaration d'acte (POST /acte/declaration).
         * Accepte les types : 'saillie' (+ acte_type_id), 'dg' (+ resultat),
         * 'poulinage' (+ resultat), 'commentaire' (+ commentaire).
         * Un email de notification est envoyé côté API.
         * Pour le type 'commentaire', aucun acte n'est créé en base :
         * le texte est transmis par mail à l'étalonnage.
         * @param {{ contract_id: number, type: string, date?: string, resultat?: string, acte_type_id?: number, commentaire?: string }} data
         * @returns {Promise<object|null>} La réponse API, ou null en cas d'erreur
         */
        /**
         * Finalise un contrat pour signature Yousign (contract_valide=1 + factures).
         * @param {number} contract_id
         */
        finalizeContract: async function(contract_id) {
            const url = this.constructRoute(Constants.CONTRACT_FINALIZE_URL, { contract_id }) + '?licence_key=' + Constants.USER_LICENCE_KEY
            return this.$request.request_post_api('ContractMixin::finalizeContract', url, {}, false)
        },

        /**
         * Génère et retourne le lien de signature Yousign pour un contrat.
         * @param {number} contract_id
         * @returns {Promise<string|null>} URL Yousign
         */
        getContractSignatureLink: async function(contract_id) {
            const url = this.constructRoute(Constants.CONTRACT_SIGNATURE_URL, { contract_id }) + '?licence_key=' + Constants.USER_LICENCE_KEY
            const result = await this.$request.request_get_api('ContractMixin::getContractSignatureLink', url)
            if (result && result.retour && result.retour.url) return result.retour.url
            return null
        },

        /**
         * Vérifie si le contrat a été signé via Yousign (avenant_status === 3).
         * @param {number} contract_id
         * @returns {Promise<{signed: boolean}>}
         */
        getContractSignatureStatus: async function(contract_id) {
            const url = this.constructRoute(Constants.CONTRACT_SIGNATURE_STATUS_URL, { contract_id }) + '?licence_key=' + Constants.USER_LICENCE_KEY
            const result = await this.$request.request_get_api('ContractMixin::getContractSignatureStatus', url)
            if (result && result.retour) return result.retour
            return { signed: false }
        },

        declarerActe: async function(data) {
            const url = Constants.DECLARER_ACTE_URL + "?licence_key=" + Constants.USER_LICENCE_KEY
            const result = await this.$request.request_post_api("ContractMixin::declarerActe", url, data, false)
            .catch(error => {
                console.error("ContractMixin::declarerActe => ERROR", error)
                return null
            })
            return result
        },
    }
}

export default ContractMixin
